import React from 'react';
import {
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogContentText,
   DialogTitle,
   makeStyles,
 } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './styles';

export default function FormDialog(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    children,
    isOpen,
    cancelText,
    submitText,
    title,
    dialogId,
    handleClose,
    onSubmit,
    onCancel,
    submitButtonDisabled,
    isDialogContentText = true,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      id={dialogId}
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        className={classes.title}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {isDialogContentText &&
          <DialogContentText id="alert-dialog-content">
            { children }
          </DialogContentText>
        }
        {!isDialogContentText &&
          <div>
            {children}
          </div>
        }
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="secondary"
          className={classes.saveButton}
          disabled={!!submitButtonDisabled}
        >
          {submitText}
        </Button>
        <Button
          onClick={onCancel}
          variant="outlined"
          className={classes.cancelButton}
        >
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

FormDialog.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  title: PropTypes.string,
  dialogId: PropTypes.string,
  handleClose: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  submitButtonDisabled: PropTypes.bool,
  isDialogContentText: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/FormDialog/index.js